import { render, staticRenderFns } from "./SpeechToText.vue?vue&type=template&id=30ea941d&scoped=true&"
import script from "./SpeechToText.vue?vue&type=script&lang=js&"
export * from "./SpeechToText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ea941d",
  null
  
)

export default component.exports